import { getAllCommissionProgress } from '../../api/commissionProgressApi';
import EditSalesCommissionModal from './editSalesCommissionModal';
import GeneralCommissionProgressList from '../common/commission/generalCommissionProgressList';
import { useState } from 'react';

export default function SalesCommissionList() {
    const [showEditCommissionModal, setShowEditCommissionModal] = useState(false);
    const [selectedCommission, setSelectedCommission] = useState(null);

    const handleViewCommissionModal = (commission) => async () => {
        setSelectedCommission(commission);
        setShowEditCommissionModal(true);
    };

    const handleCloseEditCommissionModal = () => {
        setShowEditCommissionModal(false);
        setSelectedCommission(null);
    };

    return (
        <>
            <GeneralCommissionProgressList
                fetchApi={getAllCommissionProgress}
                withUserId={false}
                onRowClick={handleViewCommissionModal}
            />
            <EditSalesCommissionModal
                show={showEditCommissionModal}
                onHide={handleCloseEditCommissionModal}
                selectedCommission={selectedCommission}
                // onSaved={fetchCommissionProgress}
                onSaved={() => window.location.reload()}
            />
        </>
    );
}